import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const AllergenFoodIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon style={{ width: 40, height: 40 }} viewBox="0 0 40 40" {...props}>
      <rect
        opacity="0.1"
        width="40"
        height="40"
        rx="20"
        fill={colors.secondary}
      />
      <path
        d="M16.3325 24.4105C16.2036 23.0789 16.3969 21.923 16.9079 20.9746C17.4262 20.0125 18.2375 19.3246 19.2543 18.9852C19.3383 18.957 19.4231 18.9316 19.5082 18.909C19.2344 18.5875 19.082 18.182 19.082 17.7543V15.377C19.082 13.8813 17.9907 12.6361 16.5626 12.3946C16.5438 11.9725 16.4317 11.4189 16.0472 10.9421C15.5431 10.317 14.7339 10 13.6422 10V11.1719C14.3579 11.1719 14.8586 11.3402 15.1303 11.672C15.3208 11.9047 15.3804 12.1954 15.3927 12.4257C14.0427 12.729 13.0313 13.937 13.0313 15.377V17.7375C13.0313 18.2949 12.7759 18.8258 12.3477 19.1574C11.62 19.7219 11.0216 20.4559 10.6169 21.2801C10.1915 22.1461 9.9845 23.0785 10.0009 24.0504C10.0572 27.3465 12.7669 30 16.0571 30C16.0817 30 16.1067 30 16.1317 29.9996C16.9575 29.9895 17.7672 29.8102 18.5121 29.4793C18.1648 29.0949 17.8434 28.6492 17.5531 28.1469C16.8977 27.0125 16.4528 25.6504 16.3325 24.4105Z"
        fill={colors.secondary}
      />
      <path
        d="M29.5258 21.53C29.1517 20.8354 28.5688 20.3398 27.8401 20.0964C26.6499 19.6991 25.2678 20.0398 24.2194 20.8978C24.2935 20.0873 24.6428 19.1139 25.7966 18.6525L25.3615 17.5645C24.0771 18.0781 23.2904 19.1052 23.0865 20.5348C23.076 20.6087 23.0673 20.6819 23.0603 20.754C22.0379 20.0028 20.7462 19.7222 19.625 20.0965C18.8963 20.3398 18.3134 20.8355 17.9393 21.53C17.5407 22.2701 17.3924 23.2011 17.4986 24.2973C17.7044 26.4202 19.0207 29.0496 20.8673 29.7753C21.1569 29.8891 21.5071 29.9759 21.9024 29.9759C22.4425 29.9759 23.0663 29.8137 23.7325 29.3368C24.8862 30.1629 25.9126 30.0446 26.5977 29.7754C28.4444 29.0496 29.7606 26.4202 29.9664 24.2974C30.0727 23.2011 29.9244 22.27 29.5258 21.53Z"
        fill={colors.secondary}
      />
    </SvgIcon>
  );
};

export default AllergenFoodIcon;
